import { native } from '@forest/native-services'
import { type Failure, withFailure } from '@forest/paywall-core'
import { m } from '~/paraglide/messages'
import { showDialog } from '~/components/dialog'

/**
 * The purchase confirmation dialog (GLOSSARY.md): the payment may have
 * succeeded but is not yet confirmed. Confirming it closes the page, so the
 * user cannot pay again while the first payment may still complete.
 */
export function showPurchaseConfirmationDialog(failure: Failure) {
  showDialog({
    title: m.dialog_confirming_perchase_title(),
    description: withFailure(
      m.dialog_confirming_perchase_description(),
      failure,
    ),
    buttonText: m.OK(),
    buttonAction: () => {
      void native.user.refreshServiceLevel()
      void native.general.close()
    },
  })
}
